import { StateSetter } from './common';
import { useStateAlt } from './useStateAlt';
import { Window, WindowParams } from './Window';

export interface ContextMenuParams extends WindowParams {
  x?: number;
  y?: number;
}

export class ContextMenu extends Window {
  public readonly positionX: number;
  public readonly setPositionX: StateSetter<number>;

  public readonly positionY: number;
  public readonly setPositionY: StateSetter<number>;

  constructor(params: ContextMenuParams) {
    super(params);
    /* eslint-disable react-hooks/rules-of-hooks */
    [this.positionX, this.setPositionX] = useStateAlt(params.x, 0);
    [this.positionY, this.setPositionY] = useStateAlt(params.y, 0);
    /* eslint-enable react-hooks/rules-of-hooks */
  }
}

export const useContextMenu = (params: ContextMenuParams = {}): ContextMenu =>
  new ContextMenu(params);
